import React, { Component } from "react";
import {
  Alert,
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Checkbox,
  Divider,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  DatePickerItem,
  InputItem,
  HeaderItem,
  BoxItem,
  ErrorItem,
} from "../../../../../Components/Items";
import ModalPdfPoliza from "../../../../../Components/ModalPdfPoliza";
import BotonesOrigenCargoAbono from "../../../../../Components/BotonesOrigenCargoAbono";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

moment.locale("es");

class VerConciliacion extends Component {
  formRef = React.createRef();
  formRefDatosConciliacion = React.createRef();
  state = {
    loading: false,
    cargosAbonos: [],
    saldoInicial: 0,
    saldoFinal: 0,
    totalCargos: 0,
    totalAbonos: 0,
    bitacoraReaperturas: [],
    modalPdfPoliza: false,
    polizaIdPdf: null,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  // El PDF de la póliza se ve en un modal, sin salir de la conciliación.
  abrirPdfPoliza = (polizaId) => {
    this.setState({ modalPdfPoliza: true, polizaIdPdf: polizaId });
  };
  cerrarPdfPoliza = () => {
    this.setState({ modalPdfPoliza: false, polizaIdPdf: null });
  };
  async consultarTodo() {
    this.setState({ loading: true });
    await this.consultarDatos(true)
    this.setState({ loading: false });
  }

  async consultarDatos(consultarInfo) {
    await axios
    .post(
      "conciliaciones/datosConciliacion",
      {
        empresaId: this.props.empresaId,
        conciliacionId: this.props.location.state.id,
        bancoId: this.props.location.state.bancoId,
      },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      if (res.data.success !== 2) {
        message.error(
          "Error no se encontro informacion para la conciliacion"
        );
      } else {

        let totalCargos = 0
        let totalAbonos = 0

          const nuevosCargosAbonos = res.data.cargosAbonos.map((valueCargoAbono) => {
              let cargo
              let abono

              if(valueCargoAbono.cargo){
                  cargo = valueCargoAbono.montoMoneda || valueCargoAbono.monto || 0
                  if(valueCargoAbono.conciliado){
                    totalCargos += valueCargoAbono.montoMoneda || valueCargoAbono.monto || 0
                  }
              }else{
                  abono = valueCargoAbono.montoMoneda || valueCargoAbono.monto || 0
                  if(valueCargoAbono.conciliado){
                    totalAbonos += valueCargoAbono.montoMoneda || valueCargoAbono.monto || 0
                  }
              }

              return {
                  ...valueCargoAbono,
                  cargo,
                  abono,
              }
          })
        this.setState({ cargosAbonos: nuevosCargosAbonos, totalCargos, totalAbonos, saldoInicial: res.data.conciliacion.saldoInicial, saldoFinal: res.data.conciliacion.saldoFinal, bitacoraReaperturas: res.data.conciliacion.bitacoraReaperturas || [] });
        if(consultarInfo){
          this.formRefDatosConciliacion.current.setFieldsValue({
            saldoFinal: res.data.conciliacion.saldoFinal,
            referencia: res.data.conciliacion.referencia,
            fechaInicial: moment(res.data.conciliacion.fechaInicial),
            fechaFinal: moment(res.data.conciliacion.fechaFinal,)
          });
        }
      }
    });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  atras() {
    this.props.history.goBack();
  }
  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={"Conciliación: " + this.props.location.state.nombre}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            {this.state.bitacoraReaperturas.length > 0 && (
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 10 }}
                message={`Esta conciliación se ha reabierto ${this.state.bitacoraReaperturas.length} vez(es)`}
                description={
                  <ul style={{ marginBottom: 0, paddingLeft: 20 }}>
                    {this.state.bitacoraReaperturas.map((b, i) => (
                      <li key={i.toString()}>
                        {moment(b.fecha).locale("es").format("ll LT")}
                        {b.usuarioNombre ? ` — ${b.usuarioNombre}` : ""}
                        {b.motivo ? `: ${b.motivo}` : ""}
                      </li>
                    ))}
                  </ul>
                }
              />
            )}
            <Row>
              <Col span={8}>
                <Form
                  ref={this.formRefDatosConciliacion}
                  name="datosConciliacion"
                  layout
                >
                  <HeaderItem>DATOS</HeaderItem>
                  <BoxItem>
                        <FormItem
                          label="Saldo Final"
                          name="saldoFinal"
                          required
                          margin
                          numberCero
                        >
                          <InputNumberItem disabled placeholder="saldoFinal" dinero />
                        </FormItem>
                        <FormItem
                          name="referencia"
                          label="Referencia"
                          margin
                          pattern
                        >
                          <InputItem disabled placeholder="Referencia" />
                        </FormItem>
                        <FormItem disabled margin label="Fecha Inicial" name="fechaInicial">
                          <DatePickerItem disabled />
                        </FormItem>
                        <FormItem disabled margin label="Fecha Final" name="fechaFinal">
                          <DatePickerItem disabled />
                        </FormItem>
                        <Row>
                    </Row>
                  </BoxItem>
                </Form>
              </Col>
              <Col span={16}>
              <HeaderItem>SALDO FINAL</HeaderItem>
                  <BoxItem>
                    <Row>
                      <Col span={5} style={{textAlign: 'center'}}>
                        <h1 style={{fontSize: 20}}>{dineroDisabledMask(this.state.saldoInicial)}</h1>
                        <p>Saldo Inicial</p>
                      </Col>
                      <Col span={1} style={{textAlign: 'center'}}>
                        <h1 style={{fontSize: 20}}>+</h1>
                      </Col>
                      <Col span={5} style={{textAlign: 'center'}}>
                        <h1 style={{fontSize: 20}}>{dineroDisabledMask(this.state.totalCargos)}</h1>
                        <p>Depositos</p>
                      </Col>
                      <Col span={1} style={{textAlign: 'center'}}>
                        <h1 style={{fontSize: 20}}>-</h1>
                      </Col>
                      <Col span={5} style={{textAlign: 'center'}}>
                      <h1 style={{fontSize: 20}}>{dineroDisabledMask(this.state.totalAbonos)}</h1>
                        <p>Pagos</p>
                      </Col>
                      <Col span={1} style={{textAlign: 'center'}}>
                        <h1 style={{fontSize: 20}}>=</h1>
                      </Col>
                      <Col span={5} style={{textAlign: 'center'}}>
                      <h1 style={{fontSize: 20}}>{dineroDisabledMask(this.state.saldoInicial + this.state.totalCargos - this.state.totalAbonos)}</h1>
                        <p>Saldo Final</p>
                      </Col>
                    </Row>
                    <Divider style={{ margin: 0, marginBottom: 10 }} />
                    <Row>
                      <Col span={8} style={{textAlign: 'center'}}>
                        <h1 style={{fontSize: 20}}>{dineroDisabledMask(this.state.saldoInicial + this.state.totalCargos - this.state.totalAbonos)}</h1>
                        <p>Saldo Final Calculado</p>
                      </Col>
                      <Col span={8} style={{textAlign: 'center'}}>
                        <h1 style={{fontSize: 20}}>{dineroDisabledMask(this.state.saldoFinal)}</h1>
                        <p>Saldo Final</p>
                      </Col>
                      <Col span={8} style={{textAlign: 'center'}}>
                        <h1 style={{fontSize: 20}}>{dineroDisabledMask((this.state.saldoInicial + this.state.totalCargos - this.state.totalAbonos) - this.state.saldoFinal)}</h1>
                        <p>Diferencia</p>
                      </Col>
                    </Row>
                    </BoxItem>
              </Col>
            </Row>
            <div style={{overflow: 'scroll', maxHeight: '50vh'}}>
              <table className="table" >
                {this.state.cargosAbonos.length > 0 ? (
                  <thead>
                    <tr>
                      <th className="th-border" style={{ width: "13%" }}>
                        Fecha
                      </th>
                      <th className="th-border" style={{ width: "30%" }}>
                        Concepto
                      </th>
                      <th className="th-border" style={{ width: "15%" }}>
                        Deposito (Cargo)
                      </th>
                      <th className="th-border" style={{ width: "15%" }}>
                        Pago (Abono)
                      </th>
                      <th className="th-border" style={{ width: "15%" }}>
                        Conciliado
                      </th>
                      <th className="th-border" style={{ width: "12%" }}>
                        Ver
                      </th>
                    </tr>
                  </thead>
                ) : null}
                {this.state.cargosAbonos.map((valueCA, index) => (
                  <tbody key={valueCA._id || index.toString()}>
                    <tr>
                      <td className="td-border-center">
                        <p style={{ marginBottom: 0 }}>
                          {moment(
                            this.state.cargosAbonos[index]
                              .fechaRegistro
                          )
                            .locale("es")
                            .format("ll")}
                        </p>
                      </td>
                      <td className="td-border">
                        <p style={{ marginBottom: 0 }}>
                          {this.state.cargosAbonos[index].concepto}
                        </p>
                      </td>
                      <td className="td-border-right">
                        <p style={{ marginBottom: 0 }}>
                          {this.state.cargosAbonos[index].cargo
                            ? dineroDisabledMask(
                              this.state.cargosAbonos[index].cargo
                              )
                            : " - "}
                        </p>
                      </td>
                      <td className="td-border-right">
                        <p style={{ marginBottom: 0 }}>
                        {this.state.cargosAbonos[index].abono
                            ? dineroDisabledMask(
                              this.state.cargosAbonos[index].abono
                              )
                            : " - "}
                        </p>
                      </td>
                      <td className="td-border-center">
                          <Checkbox
                            checked={this.state.cargosAbonos[index].conciliado}
                            disabled
                          />
                      </td>
                      <td className="td-border-center">
                        <BotonesOrigenCargoAbono
                          ventaId={valueCA.ventaId}
                          polizaId={valueCA.polizaId}
                          facturaId={valueCA.facturaId}
                          history={this.props.history}
                          onVerPoliza={this.abrirPdfPoliza}
                        />
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
              </div>
          </Spin>
        </div>
        <ModalPdfPoliza
          visible={this.state.modalPdfPoliza}
          polizaId={this.state.polizaIdPdf}
          onCancel={this.cerrarPdfPoliza}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerConciliacion);
